import { AxiosInstance } from "axios";
import { Commune } from "../types/Commune";

export const communeService = {
  getAll: async (api: AxiosInstance): Promise<Commune[]> => {
    try {
      const response = await api.get('/commune');
      return response.data as Commune[];
    } catch (error: any) {
      console.error('Erreur lors de la récupération des communes :', error);
      return [];
    }
  }
};
